import { render, staticRenderFns } from "./Detail-Sales-Summary.vue?vue&type=template&id=4027b1dd&"
import script from "./Detail-Sales-Summary.vue?vue&type=script&lang=js&"
export * from "./Detail-Sales-Summary.vue?vue&type=script&lang=js&"
import style0 from "./Detail-Sales-Summary.vue?vue&type=style&index=0&id=4027b1dd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports